import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ac829b36&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac829b36')) {
      api.createRecord('ac829b36', component.options)
    } else {
      api.reload('ac829b36', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=ac829b36&", function () {
      api.rerender('ac829b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/Index.vue"
export default component.exports